import * as React from 'react';
import useDocumentTitle from '../../hooks/useDocumentTitle';
import { TITLE_APP, getLanguageDefault } from '../../utils/Utils';
import Layout from '../layout/layout';
import { withTranslation } from 'react-i18next';
import { useLayoutEffect } from 'react';

const PageComponent = (props: any) => {
  useDocumentTitle(`${TITLE_APP}${props.title}`);

  const { i18n } = props;
  var timeoutLanguage: any = null;
  useLayoutEffect(() => {
    timeoutLanguage = setTimeout(() => {
      i18n.changeLanguage(getLanguageDefault().code.toLowerCase());
    }, 10);

    return () => {
      clearTimeout(timeoutLanguage);
    };
  }, []);

  return (
    <Layout>
      <props.component />
    </Layout>
  );
};

export default withTranslation('language')(PageComponent);
